import styles from './ListItem.module.scss'
import { useEffect, useRef} from "react";
export type ListItemProps = {
    id:number,
    renderedTemplate:string
    name:string
    pattern:string
    jsonExample:string
    selectedId:number
    setId:(value:number)=>void
    setSelectedId:(value:number)=>void
    setName:(value:string)=>void
    setPattern:(value:string)=>void
    setJsonExample:(value:string)=>void
    deleteByName:(value:string)=>void
    showDemo:(value:string)=>void
}
export default function ListItem(props:ListItemProps){
    const fr = useRef<HTMLIFrameElement>(null);
    useEffect(() => {
        if(fr.current!==null && fr.current.contentWindow!==null){
            fr.current.contentWindow.document.open();
            fr.current.contentWindow.document.write(props.renderedTemplate);
            fr.current.contentWindow.document.close();
        }
    }, []);
    const select = ()=>{
        props.setId(props.id)
        props.setPattern(props.pattern)
        props.setName(props.name)
        props.setJsonExample(props.jsonExample)
    }
    return(
        <div className={styles.ListItem} style={{color:props.id===props.selectedId?'#2aa71f':'#1b1f96'}}>
            <div className={styles.ItemName}>{props.name}</div>
            <button className={styles.ChoiceButton} onClick={select}>Выбрать</button>
            <div className={styles.ItemJson}>{props.jsonExample}</div>
            <button className={styles.ChoiceButton} onClick={()=>props.showDemo(props.renderedTemplate)}>Посмотреть в новом окне</button>
            <button className={styles.DeleteButton} onClick={()=>props.deleteByName(props.name)}>Удалить</button>
        </div>
    )
}